var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pageSteps card-styling"},_vm._l((_vm.items),function(item,index){return _c('span',{key:index,staticClass:"breadcrumb-item-wrapper"},[(item.route)?_c('p',{style:({
        fontWeight: item.active ? '500' : '300',
        fontStyle: 'normal',
        cursor: 'pointer',
        margin: 0,
        display: 'inline',
      }),attrs:{"role":"button"},on:{"click":function($event){return _vm.navigate(item.route)}}},[_vm._v(" "+_vm._s(item.label)+" ")]):_c('p',{style:({
        fontWeight: item.active ? '500' : '300',
        fontStyle: 'normal',
        margin: 0,
        display: 'inline',
      })},[_vm._v(" "+_vm._s(item.label)+" ")]),(index < _vm.items.length - 1)?_c('img',{staticStyle:{"margin":"0 17px"},attrs:{"src":require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`),"alt":""}}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }